module.exports = __webpack_public_path__ + "img/cat.5eee6363.jpg";